exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".numberInput {\n    height: 4rem;\n    width: 4rem;\n    margin: 0.5rem;\n    text-align: center;\n    font-size: 2.5rem;\n}\n\n .codeInputWrapper {\n    display: flex;\n    margin: auto;\n    margin-bottom: 5rem;\n }", ""]);

// exports
